import { render } from "./VerifyOTP.vue?vue&type=template&id=6e567baf&scoped=true"
import script from "./VerifyOTP.vue?vue&type=script&lang=js"
export * from "./VerifyOTP.vue?vue&type=script&lang=js"

import "./VerifyOTP.vue?vue&type=style&index=0&id=6e567baf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e567baf"]])

export default __exports__